// extracted by mini-css-extract-plugin
module.exports = {"FaqContainer":"Faq_FaqContainer__lE8Kc","Spinner":"Faq_Spinner__2ZwHE"};